import {AxiosResponse} from 'axios';
//api
import {adminAPI} from '@/core/api';
//types
import {IUserOrganizationSettingData} from '@/utils/types';
//enum
import {API_URL} from '../enums/api-url.enum';

class AdminNotificationSettingService {
	static getAllNotificationSetting = async (adminId: number): Promise<AxiosResponse<IUserOrganizationSettingData>> =>
		adminAPI.get(`${API_URL.ADMIN_NOTIFICATION_SETTING}/${adminId}`);

	static updateNotificationSetting = async (
		adminId: number,
		reqBody: IUserOrganizationSettingData
	): Promise<AxiosResponse<IUserOrganizationSettingData>> =>
		adminAPI.put(`${API_URL.ADMIN_NOTIFICATION_SETTING}/${adminId}`, reqBody);
}

export {AdminNotificationSettingService};
